import type { SidebarNavItem } from '@/lib/api'
import { adminRoutes, workerRoutes } from '@/lib/navigation/routes'

/** Default admin sidebar when /api/sidebar is unavailable. */
export const defaultAdminSidebar: SidebarNavItem[] = [
  { icon: 'dashboard', label: 'Панель', path: adminRoutes.dashboard.path, match: [adminRoutes.dashboard.path] },
  { icon: 'nomenclature', label: 'Номенклатура', path: adminRoutes.nomenclature.path, match: [adminRoutes.nomenclature.path] },
  { icon: 'tasks', label: 'Задания', path: adminRoutes.tasks.path, match: ['/admin/tasks'] },
  { icon: 'document', label: 'Создать задание', path: '/admin/tasks/new', match: ['/admin/tasks/new'] },
  { icon: 'shipments', label: 'Отгрузки', path: adminRoutes.shipments.path, match: [adminRoutes.shipments.path] },
  { icon: 'fields', label: 'Метаданные', path: adminRoutes.metadata.path, match: [adminRoutes.metadata.path] },
  { icon: 'settings', label: 'Настройки', path: adminRoutes.settings.path, match: [adminRoutes.settings.path, '/admin/settings'] },
]

export const defaultWorkerSidebar: SidebarNavItem[] = [
  { icon: 'tasks', label: 'Задания', path: workerRoutes.tasks.path, match: ['/worker/tasks'] },
]

export function getDefaultSidebar(role: string | null | undefined): SidebarNavItem[] {
  return role === 'worker' ? defaultWorkerSidebar : defaultAdminSidebar
}
